"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageValidator = exports.MessageSender = void 0;
const util_1 = require("../util");
var MessageSender;
(function (MessageSender) {
    MessageSender["Manager"] = "manager";
    MessageSender["Employee"] = "employee";
})(MessageSender = exports.MessageSender || (exports.MessageSender = {}));
exports.MessageValidator = util_1.generateValidator('Message');
//# sourceMappingURL=message.js.map